export default "__VITE_ASSET___$aHvjhe__"